export const SECOND_DFP_SELECTOR = '.js-dfp-right-block__bottom'